<template>
	<v-card class="my-3">
		<v-card-title>{{ trans('advert.interested_people') }}</v-card-title>
	    <v-list v-if="users && users.length" tag="ul" two-line>
			<template v-for="user,i in users">
				<user-info 
				:user="user"
				:key="user.uuid" 
				/>
				<v-divider :key="`d-${user.uuid}`" inset v-if="i != users.length-1"></v-divider>
    		</template>
	    </v-list>

        <v-card-text v-else>
        	{{ trans('advert.no_interested_people') }}
		</v-card-text>
    </v-card>
</template>

<script>
	import UserInfo from './UserInfo';
	export default {
		components: {
			'user-info': UserInfo,
		},
		props: [
			'users'
		],
	}
</script>